@import '../../../constants/spacing.module.less';

.breadcrumbs {
  margin: 0;
}

.breadcrumbs-list {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
}

.breadcrumbs-separator {
  display: flex;
  align-items: center;
  margin-left: @space-8;
  user-select: none;
  margin-right: @space-8;
}
